/**
 * THE "USE AN IMAGE I ALREADY HAVE" SOURCE.
 *
 * `ConceptRenditionService.attachMedia` (via `renditionLifecycle.attachMedia`)
 * exists and is fully wired — but before this file, its only caller was
 * `useWorkbenchPrompt.submit`, immediately after the Workbench's OWN
 * `/api/generate-image` response. A media id the Workbench did not itself
 * generate — a Studio image, an Assets upload, anything already in
 * `useMediaLibrary()` — had no path in. That is a real gap, not a fixture
 * gap: the writer exists, is tested, and was simply unreachable from the UI.
 *
 * This function is the other caller. It does NOT touch generation, spends no
 * image credit, and makes no request to `/api/generate-image` — it binds an
 * already-persisted `media` row to one rendition, exactly the operation
 * `ConceptRenditionService.attachMedia`'s own docblock describes ("Bind an
 * already-persisted library item to one rendition only").
 *
 * Kept React-free, like `numeric.ts`, so the seam is directly unit-testable
 * without mounting the 1,600+-line design canvas body that calls it.
 */

export interface ExistingMediaLifecycle {
  attachMedia: (renditionId: string, mediaId: string) => Promise<unknown>;
}

export async function attachExistingMedia(
  renditionId: string,
  mediaId: string,
  lifecycle: ExistingMediaLifecycle,
): Promise<void> {
  await lifecycle.attachMedia(renditionId, mediaId);
}
